import { render, staticRenderFns } from "./MSGroupMembersPendingList.vue?vue&type=template&id=c1de9b84"
import script from "./MSGroupMembersPendingList.vue?vue&type=script&lang=js"
export * from "./MSGroupMembersPendingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports